import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';

import { toObservable } from '@angular/core/rxjs-interop';
import { Company } from '@prisma/client';
import { Observable } from 'rxjs';

import { UserStore } from '@hmax-order/frontend/state';

@Component({
  selector: 'hmax-selected-company',
  standalone: true,
  templateUrl: './selected-company.component.html',
  styleUrls: ['./selected-company.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AsyncPipe],
})
export class SelectedCompanyComponent {
  private _userStore = inject(UserStore);

  readonly currentCompany$: Observable<Partial<Company> | undefined> = toObservable(this._userStore.getCurrentCompany);
}
